module.exports = __webpack_public_path__ + "img/img2_9.dad0ba64.jpeg";